import * as React from "react"
import { Toaster as SonnerToaster, toast } from "sonner"
import { useTheme } from "../ThemeContext"

export { toast }

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  const { isDark } = useTheme()
  return (
    <SonnerToaster
      theme={isDark ? "dark" : "light"}
      className="pointer-events-auto"
      toastOptions={{
        classNames: {
          toast:
            "group rounded-md border border-cloverhound-gray-250 dark:border-cloverhound-gray-800 bg-white dark:bg-cloverhound-gray-900 text-cloverhound-gray-900 dark:text-cloverhound-gray-50 shadow-lg",
          description: "text-cloverhound-gray-700 dark:text-cloverhound-gray-400",
          actionButton:
            "bg-cloverhound-indigo-600 text-white hover:bg-cloverhound-indigo-500",
          cancelButton:
            "bg-cloverhound-gray-100 text-cloverhound-gray-800 dark:bg-cloverhound-gray-800 dark:text-cloverhound-gray-300",
          error: "border-cloverhound-red-500/40 [&>div>div>div]:text-cloverhound-red-500",
          success: "[&>div>div>div]:text-cloverhound-green-500",
          warning: "[&>div>div>div]:text-cloverhound-yellow-500",
          info: "[&>div>div>div]:text-cloverhound-blue-500",
        },
      }}
      {...props}
    />
  )
}
